import { useCallback, useEffect, useState } from "react";
import { bidders_ask_list } from "../../reduxData/user/userAction";
import CustomPagination from "./Pagination";
import { formatDollarPrice } from "../../utils/Price";
import { useLocation, useSearchParams } from "react-router-dom";
import { Input } from "@mui/joy";
import { generateProductDetailsUrl } from "../../utils/FrontendUrl";

const { REACT_APP_IMAGE_URL } = process.env;

const BidsAndAsks = ({ type }) => {
  const [record, setRecords] = useState([]);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("updated_at");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [searchParams, setSearchParams] = useSearchParams();
  // console.log("params",searchParams.get("search"));

  const { pathname } = useLocation();

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder((prev) => (prev === "ASC" ? "DESC" : "ASC"));
    } else {
      setSortBy(field);
      setSortOrder("DESC");
    }
    setPage(1);
  };


  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await bidders_ask_list(
        type,
        page,
        limit,
        search,
        sortBy,
        sortOrder
      );
      if (res) {
        setRecords(res?.data?.data || []);
        setTotal(res?.data?.total);
      }
      window.scrollTo({ top: 0, behavior: "instant" });
    } finally {
      setLoading(false);
    }
  }, [page, limit, type, search, sortBy, sortOrder]);

  useEffect(() => {
    setSearch("");
    setRecords([]);
    setTotal("");
    setLoading(true);
    setPage(1);
  }, [type]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(timer);
  }, [page, limit, search, type, sortBy, sortOrder]);

  useEffect(() => {
    const email = searchParams.get("search");
    if (email) {
      setSearch(email);
    }
  }, [searchParams]);

  return (
    <div className="container">
      <>
        <div className="flex-md-row flex-column gap-2 d-flex justify-content-between align-items-center mb-2">
          <h3 className="fw-600 col-md-6">
            {type == "seller" ? "Seller Asks" : "Buyer Bids"}
          </h3>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <Input
              id="emailInput"
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                if (searchParams.get("search")) {
                  setSearchParams({});
                  console.log("tets");
                }
              }}
            />
          </div>
        </div>
        {loading ? (
          <div className="table-overlay-loader d-flex justify-content-center align-items-center mt-5">
            <div className="spinner-border text-primary" />
          </div>
        ) : (
          <>
            <div className="table-responsive mt-3">
              <table className="table user-management-table table-hover ">
                <thead className="border-gray">
                  <th className="text-nowrap fw-bold text-center">Sr. No.</th>
                  <th className="text-nowrap fw-bold text-center ">
                    {type == "seller" ? "Seller" : "Buyer"}
                  </th>
                  <th className="text-nowrap fw-bold text-center ">Email</th>
                  <th className="text-nowrap fw-bold text-center ">
                    Product Name
                  </th>
                  <th className="text-nowrap fw-bold text-center">Image</th>
                  <th className="text-nowrap fw-bold text-center">Size</th>
                  <th className="text-nowrap fw-bold text-center">
                    Updated At
                    <i
                      className="bi bi-arrow-down-up ms-1 cursor-pointer"
                      onClick={() => handleSort("updated_at")}
                    ></i>
                  </th>

                  <th className="text-nowrap fw-bold text-center amount-bg">
                    Amount
                    <i
                      className="bi bi-arrow-down-up ms-1 cursor-pointer"
                      onClick={() => handleSort("amount")}
                    ></i>
                  </th>
                </thead>
                <tbody>
                  {record?.length > 0 ? (
                    record?.map((i, idx) => (
                      <tr>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-center">
                          {`${i?.shipping_addresses?.[0]?.first_name || ""} ${
                            i?.shipping_addresses?.[0]?.last_name || ""
                          }`}
                          {/* : `${i?.buyer_details?.[0]?.first_name || ""} ${
                              i?.buyer_details?.[0]?.last_name || ""
                            } */}
                        </td>
                        <td className="text-center">
                          {i?.seller_email || i?.buyer_email}
                        </td>
                        <td className="text-center">
                          <a
                            href={generateProductDetailsUrl(
                              i?.auction_id || i?.master_product_id,
                              i?.product_name || i?.model
                            )}
                            target="_blank"
                            className="fw-bolder mb-1"
                          >
                            {i?.product_name || i?.model}
                          </a>
                          <br />
                          <a
                            href={generateProductDetailsUrl(
                              i?.auction_id || i?.master_product_id,
                              i?.product_name || i?.model
                            )}
                            target="_blank"
                          >
                            {i?.subtitle}
                          </a>
                        </td>

                        <td className="image-product text-center">
                          <img
                            className="img-fluid"
                            src={`${REACT_APP_IMAGE_URL}${i?.images?.[0]}`}
                          />
                        </td>
                        <td className="text-center">
                          {type == "seller"
                            ? `${i?.size?.[0]?.sizeText || "-"}`
                            : `${i?.size_name?.sizeText || "-"}`}
                        </td>
                        <td className="text-center">
                            {i?.updated_at ? new Date(i?.updated_at).toLocaleString():"-"}
                        </td>
                        <td className="text-center">
                          {type == "seller"
                            ? formatDollarPrice(i?.buy_now)
                            : formatDollarPrice(
                                i?.bid_amount
                              )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No Record
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {total > 0 && (
              <CustomPagination
                total={total}
                resetPage={pathname}
                currentPage={page}
                perPage={limit}
                onPageChange={(currentPage, perPage) => {
                  setPage(currentPage);
                  setLimit(perPage);
                  // setCurrentPage(currentPage);
                  // setPerPage(perPage);
                }}
              />
            )}
          </>
        )}
      </>
    </div>
  );
};
export default BidsAndAsks;
